import { Loading3QuartersOutlined } from "@ant-design/icons";
import React from "react";

const Loader = () => (<div className="h-screen w-screen flex justify-center items-center"><Loading3QuartersOutlined size={100} className="animate-spin" /></div>)


export default React.memo(Loader);